export default __webpack_public_path__ + "static/media/riftbound_epic.c756fef5.svg";